/* Ferrer Connect scripts
========================================================================== */

(function($){

"use strict";

// contest modal
if (
	$('#contest-modal').length &&
	(typeof FERRER_CONTEST_POPUP !== 'undefined')
) {
	if ( FERRER_VER_POPUP.verPopup && ! $.cookie(FERRER_VER_POPUP.cookieName) ) {
		// code

	} else if ( ! $.cookie(FERRER_CONTEST_POPUP.cookieName) ) {
		$('#contest-modal').modal();
	}

    if ( $.cookie(FERRER_CONTEST_POPUP.acceptanceName) ) {
        $.removeCookie(FERRER_CONTEST_POPUP.acceptanceName, { path: '/' });
    }

	$('#contest-modal').on('hidden.bs.modal', function (event) {
		$.cookie(FERRER_CONTEST_POPUP.cookieName, 'true', { expires: 4, path: '/' });
	});

    $('#contest-modal').find('#your-ferrer-acceptance').on('change', function() {
        if ($(this).is(':checked')) {
            $('#contest-modal').find('.wpfc-login').removeClass('disabled');
        } else {
            $('#contest-modal').find('.wpfc-login').addClass('disabled');
        }
    });
}

})(jQuery);

/*----------  Base functions  ----------*/

function ferrerLoginContest() {
	if ( ! jQuery('#contest-modal').find('#your-ferrer-acceptance').is(':checked') ) {
		return;
	}

	jQuery.cookie(FERRER_CONTEST_POPUP.acceptanceName, 'true', { path: '/' });

	ferrerLogin();
}
